const React = require('react');
const Ripple = require('../Ripple');


module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`dn h60 w270 ttU usN tdN ph15 lts0em bgE70F0F
        bgA3A7AC.disabled layoutRow fhaC fvaC cF lh fw4 f16 ov dn
        bgBF0808:not[.disabled]:h ` + (props.className || '')
      }
    />
  );
};
